import { FC } from 'react';

import { useTheme } from 'styled-components';

import { IHelperTextProps } from './types';
import { Container } from './styles';
import { Typography } from '../../Typography';
import { Icon } from '../../Icons';

export const HelperText: FC<IHelperTextProps> = ({
  children,
  isError,
  isDisabled,
}) => {
  const theme = useTheme();

  return (
    <Container>
      <Icon
        type="information-fill"
        size={16}
        color={
          isDisabled
            ? theme.neutral[600]
            : isError
            ? theme.red[600]
            : theme.neutral[500]
        }
      />

      <Typography.Paragraph
        size="x-small"
        color={isDisabled ? 'neutral.600' : isError ? 'red.600' : 'neutral.400'}
      >
        {children}
      </Typography.Paragraph>
    </Container>
  );
};
